// Utility: fetch latest cart and fire event
function fireCartUpdated() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
    });
}

// Increase Quantity
document.addEventListener('rebuy:smartcart.line-item-increase', (event) => {
  const smartcart = event.detail.smartcart
  const item = event.detail.item

  // console.log('qty naik', {
  //   title: item.product_title,
  //   qty: item.quantity,
  //   line_price: item.line_price,
  // })

  payload = {
    type: "single",
    items: [item],
  };
  window.showCustomPopup?.(payload);

})

// Patch fetch globally
const originalFetch = window.fetch;
window.fetch = function (...args) {
  const url = args[0];

  const isCartApi =
    typeof url === "string" &&
    (url.includes("/cart/add") ||
     url.includes("/cart/change") ||
     url.includes("/cart/update"));

  if (!isCartApi) return originalFetch.apply(this, args);

  return originalFetch.apply(this, args).then(async (res) => {
    try {
      if (url.includes("/cart/add")) {
        // try to read response
        const data = await res.clone().json();

        let payload;

        if (Array.isArray(data?.items)) {
          // multiple add → cart object (punya items[])
          payload = {
            type: "multiple",
            items: data.items,                 // array of line_items
            cart: {
              item_count: data.item_count,
              total_price: data.total_price,
              currency: data.currency,        // kalau tersedia
            },
          };
        } else if (data?.key) {
          // single add → satu line_item
          payload = {
            type: "single",
            items: [data],
          };
        } else if (data?.status && data?.message) {
          // error shape dari Shopify (mis. 422)
          payload = { type: "error", error: data };
        } else {
          // bentuk tak terduga → fallback fetch cart
          const cart = await fetch("/cart.js").then((r) => r.json());
          payload = { type: "cart", items: cart.items, cart };
        }

        window.showCustomPopup?.(payload);
      }
    } catch (e) {
      // kalau response bukan JSON / gagal parse → fallback ke /cart.js
      try {
        const cart = await fetch("/cart.js").then((r) => r.json());
        window.showCustomPopup?.({ type: "cart", items: cart.items, cart });
      } catch (_) {}
    }

    // event setelah update cart
    setTimeout(fireCartUpdated, 300);
    return res;
  });
};


// Initialize on page load
document.addEventListener("DOMContentLoaded", () => {
  fireCartUpdated();
});